export default "__VITE_ASSET__6c6c1dec__"